var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUpload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.611,
    height: 23.611,
    viewBox: "0 0 23.611 23.611",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "upload_",
    "data-name": "upload ",
    transform: "translate(-2 -2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_118",
    "data-name": "Trac\\xE9 118",
    d: "M22.069,23.444H5.542A3.546,3.546,0,0,1,2,19.9V15.181a1.181,1.181,0,0,1,2.361,0V19.9a1.182,1.182,0,0,0,1.181,1.181H22.069A1.182,1.182,0,0,0,23.25,19.9V15.181a1.181,1.181,0,0,1,2.361,0V19.9A3.546,3.546,0,0,1,22.069,23.444Z",
    transform: "translate(0 2.167)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_119",
    "data-name": "Trac\\xE9 119",
    d: "M18.986,10.264a1.177,1.177,0,0,1-.835-.346L13.083,4.85,8.015,9.918a1.181,1.181,0,0,1-1.67-1.67l5.9-5.9a1.181,1.181,0,0,1,1.67,0l5.9,5.9a1.181,1.181,0,0,1-.835,2.015Z",
    transform: "translate(0.722 0)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ligne_85",
    "data-name": "Ligne 85",
    d: "M.181,15.528A1.181,1.181,0,0,1-1,14.347V.181a1.181,1.181,0,0,1,2.361,0V14.347A1.181,1.181,0,0,1,.181,15.528Z",
    transform: "translate(13.625 3)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.2ecb9b66f24f5591d3ef12f083e6604d.svg";
export { ForwardRef as ReactComponent };